import { StatusIndicator } from './StatusIndicator';
import { IStatusIndicator } from './StatusIndicator.interfaces';

export default StatusIndicator;
export { StatusIndicator, IStatusIndicator };
